import { api } from './palmPayApi';
import type { TransferRequest, Transaction } from '../types';

// Transfer API
export const transfer = async (data: TransferRequest): Promise<any> => {
  const response = await api.post('/transfer', data);
  return response.data;
};

export const getTransferHistory = async (userId: string): Promise<{ transactions: Transaction[] }> => {
  const response = await api.get<{ transactions: Transaction[] }>('/transfer/history', { params: { userId } });
  return response.data;
};

export const transferPalm = async (data: TransferRequest): Promise<any> => {
  const response = await api.post('/transfer/palm', data);
  return response.data;
};